import React, { useEffect } from "react";
import Router from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import ScrollToTop from "./pages/components/ScrollToTop";
import logger from "./utils/logger";
import { config } from "./config/config";
import Footer from "./pages/components/Footer";
import { Provider } from "react-redux";
import store from "./redux/store"
import { HelmetProvider } from "react-helmet-async"
import { useLocation } from 'react-router-dom';


function App() {

  const location = useLocation();
  const isCheckout = location.pathname === '/cart-checkout';

  // useEffect(() => {
  //   if (config.REACT_APP_MODE === "dev" || config.REACT_APP_MODE === "prod") {
  //     console.warn = () => {};  
  //     console.error = () => {}; 
  //   }
  // }, []);
  function handleResize() {

    const hrefArray = window.location.href.split("/")
    let allowedAddress = hrefArray.length > 4 && (
      hrefArray[4].startsWith("reset-pwd") ||
      hrefArray[4].startsWith("auth") ||
      hrefArray[4].startsWith("order"));
    if (allowedAddress)
      return '';

    // if(Number(window.screen.width) >= 768) {
    //   window.open(config.EVENTS_PAGE_BIG_SCREEN_URL,'_self');
    //   logger('App.js', 'large screen detected, redirecting', window.screen.width);
    // }
    return '';

  }
  useEffect(() => {
    handleResize();
    const handleUnload = () => {
    sessionStorage.removeItem('shopNowFilters');
    sessionStorage.removeItem('campaignFilter');
  };

  window.addEventListener('beforeunload', handleUnload);

  return () => {
    window.removeEventListener('beforeunload', handleUnload);
  };
  }, []);

  return (
    <HelmetProvider>
      <div id="App" style={{
        overflow: isCheckout ? 'visible' : 'hidden',
      }} >
        <Provider store={store}>
          <ScrollToTop />
          <Router />
          <Footer />
        </Provider>
      </div>
    </HelmetProvider>
  );
}

export default App;
